import Vue from 'vue';
import VueRouter from 'vue-router';

import { UserRouter }  from './User';
import { EventsRouter }  from './Events';
import { CheckoutRouter } from './Checkout';
import { MiniSitesRouter } from './MiniSites';
import { AsDeporteRouter } from './AsDeporte';
import { ErrorPagesRouter } from './ErrorPages';
import { AdminRouter, ADMIN_LAYOUT } from './Admin';
import { PurchaseOrdersRouter } from './PurchaseOrders';
import { LandingRouter, CHUSPIC_LAYOUT_WEB, LANDING_NAME_ROUTER } from './Landing';

Vue.use(VueRouter);

const MASTER_TENANT_NAME = 'public';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/home/Index')
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('../views/Maintenance'),
        meta: {
            layout: "MaintenanceLayout"
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/Contact')
    },
    {
        path: '/privacy-policies',
        name: 'PrivacyPolicies',
        component: () => import('../views/PrivacyPolicies')
    },
    {
        path: '/terms-conditions',
        name: 'TermsConditions',
        component: () => import('../views/TermConditions')
    },
    ...UserRouter,
    ...AdminRouter,
    ...EventsRouter,
    ...LandingRouter,
    ...CheckoutRouter,
    ...MiniSitesRouter,
    ...AsDeporteRouter,
    ...ErrorPagesRouter,
    ...PurchaseOrdersRouter
]

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to, from, next) => {
    const tenantName = document.querySelector('body').dataset.tenantName;

    if(tenantName == MASTER_TENANT_NAME && to.meta.layout != CHUSPIC_LAYOUT_WEB && to.meta.layout != ADMIN_LAYOUT) {
      router.replace({ name: LANDING_NAME_ROUTER });
      return;
    }
    window.scrollTo(0, 0);
    next();
});

export default router;